import { apiClient } from '@app/lib'
import { type ApiResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useRemovePhoneNumber = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['removePhoneNumber'],
    mutationFn: async () => {
      const { data } = await apiClient.post<ApiResponse>('/api/mfa/remove_phone_number')

      return data
    },
    onSuccess: () =>
      queryClient.removeQueries({
        queryKey: ['phone']
      })
  })
}
